/**
 * The in-portal mailbox — direction and status of one stored message, plus
 * the folder views the admin UI renders. Views are predicates over a
 * message's flags, not a stored column, so a message can't drift out of sync
 * with which folder it's "in".
 */
export const MAIL_DIRECTIONS = ['inbound', 'outbound'];
export const MAIL_STATUSES = ['received', 'draft', 'queued', 'sent', 'failed'];
export const MAIL_VIEWS = ['inbox', 'starred', 'sent', 'drafts', 'archive', 'junk', 'trash'];
/** Mailgun rejects a single stored message (all parts + attachments) over 25MB. */
export const MAX_MAIL_MESSAGE_TOTAL_BYTES = 25 * 1024 * 1024;
/** Per-file cap on a composed attachment — generous for a signed contract or a repair photo, not a movie. */
export const MAX_MAIL_ATTACHMENT_BYTES = 10 * 1024 * 1024;
/** A pasted signature block or a long thread quote can get large; this is not the same limit as the attachment cap. */
export const MAX_MAIL_BODY_BYTES = 5 * 1024 * 1024;
//# sourceMappingURL=mail.js.map